import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from '@/app/store';
import { App } from './App';
import { seedOverview } from '@/features/events/seedOverview';
import '@/styles/index.css';

const container = document.getElementById('root');
if (!container) throw new Error('#root is missing from index.html');

// Before the first render, so the homepage starts from the numbers the server already drew.
seedOverview(store.dispatch);

createRoot(container).render(
  <StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </StrictMode>,
);
